import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid h-100 p-0" }
const _hoisted_2 = { class: "row h-100 g-0" }
const _hoisted_3 = { class: "col-12 col-md-3 col-lg-3 h-100" }
const _hoisted_4 = {
  class: "overflow-y-auto h-100 pt-4 px-3",
  style: {"height":"calc(100vh - 60px)"}
}
const _hoisted_5 = { class: "mb-3 pb-3 border-bottom" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "form-label" }
const _hoisted_9 = { class: "form-label mt-3" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-label mt-3" }
const _hoisted_12 = { value: "product_supply" }
const _hoisted_13 = { value: "product_supply_commissioning" }
const _hoisted_14 = { value: "full_service" }
const _hoisted_15 = { value: "complete_solution" }
const _hoisted_16 = { class: "form-label mt-3" }
const _hoisted_17 = { class: "row g-2" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "col" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "col" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = { class: "mb-3 pb-3 border-bottom" }
const _hoisted_25 = { class: "mb-3" }
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = { class: "form-label" }
const _hoisted_31 = { value: "standard" }
const _hoisted_32 = { value: "installer" }
const _hoisted_33 = { value: "distributor" }
const _hoisted_34 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_35 = { class: "form-label" }
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "mb-3 pb-3 border-bottom" }
const _hoisted_38 = { class: "mb-3" }
const _hoisted_39 = { class: "mb-3" }
const _hoisted_40 = ["placeholder"]
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = ["placeholder"]
const _hoisted_43 = { class: "mb-3" }
const _hoisted_44 = { class: "mb-3" }
const _hoisted_45 = { class: "col-12 col-md-9 col-lg-9 h-100 d-none d-md-block p-4" }
const _hoisted_46 = {
  class: "position-fixed h-100",
  style: {"top":"90px","left":"33%","right":"10px"}
}
const _hoisted_47 = {
  class: "col-12 d-md-none p-4",
  style: {"height":"250px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapComponent = _resolveComponent("MapComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("project.info.title")), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("project.info.name")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.project.project_name) = $event)),
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.project.project_name]
              ]),
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("project.info.id")), 1),
              _createElementVNode("input", {
                type: "text",
                value: 
                  'id' in _ctx.project
                    ? String(_ctx.project.id)
                    : 'Will be generated after saving'
                ,
                class: "form-control",
                disabled: ""
              }, null, 8, _hoisted_10),
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("project.info.serviceType")), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.project.service_type) = $event)),
                class: "form-select"
              }, [
                _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t("project.info.serviceTypes.productSupply")), 1),
                _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.$t("project.info.serviceTypes.productSupplyCommissioning")), 1),
                _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t("project.info.serviceTypes.fullService")), 1),
                _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.$t("project.info.serviceTypes.completeSolution")), 1)
              ], 512), [
                [_vModelSelect, _ctx.project.service_type]
              ]),
              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("project.info.temperature")) + " (°C)", 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.project.temperature_min) = $event)),
                    placeholder: _ctx.$t('project.info.temperatureMin'),
                    class: "form-control",
                    step: "1",
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (
                      _ctx.project.temperature_min = String(
                        Math.round(Number(_ctx.project.temperature_min))
                      )
                    ))
                  }, null, 40, _hoisted_19), [
                    [_vModelText, _ctx.project.temperature_min]
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.project.temperature_avg) = $event)),
                    placeholder: _ctx.$t('project.info.temperatureNormal'),
                    class: "form-control",
                    step: "1",
                    onInput: _cache[5] || (_cache[5] = ($event: any) => (
                      _ctx.project.temperature_avg = String(
                        Math.round(Number(_ctx.project.temperature_avg))
                      )
                    ))
                  }, null, 40, _hoisted_21), [
                    [_vModelText, _ctx.project.temperature_avg]
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.project.temperature_max) = $event)),
                    placeholder: _ctx.$t('project.info.temperatureMax'),
                    class: "form-control",
                    step: "1",
                    onInput: _cache[7] || (_cache[7] = ($event: any) => (
                      _ctx.project.temperature_max = String(
                        Math.round(Number(_ctx.project.temperature_max))
                      )
                    ))
                  }, null, 40, _hoisted_23), [
                    [_vModelText, _ctx.project.temperature_max]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_24, [
            _createElementVNode("h3", _hoisted_25, _toDisplayString(_ctx.$t("project.info.clientData")), 1),
            _createElementVNode("div", _hoisted_26, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.project.client_name) = $event)),
                placeholder: _ctx.$t('project.info.clientName'),
                class: "form-control mb-2"
              }, null, 8, _hoisted_27), [
                [_vModelText, _ctx.project.client_name]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.project.client_email) = $event)),
                placeholder: _ctx.$t('project.info.clientEmail'),
                class: "form-control mb-2"
              }, null, 8, _hoisted_28), [
                [_vModelText, _ctx.project.client_email]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.project.client_phone) = $event)),
                placeholder: _ctx.$t('project.info.clientPhone'),
                class: "form-control mb-2"
              }, null, 8, _hoisted_29), [
                [_vModelText, _ctx.project.client_phone]
              ]),
              _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("project.info.clientType")), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.project.client_type) = $event)),
                class: "form-select"
              }, [
                _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.$t("project.info.clientTypes.standard")), 1),
                _createElementVNode("option", _hoisted_32, _toDisplayString(_ctx.$t("project.info.clientTypes.installer")), 1),
                _createElementVNode("option", _hoisted_33, _toDisplayString(_ctx.$t("project.info.clientTypes.distributor")), 1)
              ], 512), [
                [_vModelSelect, _ctx.project.client_type]
              ]),
              (_ctx.project.client_type === 'standard')
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("project.info.discount")), 1),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.discountPercentage) = $event)),
                      class: "form-select"
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(26, (i) => {
                        return _createElementVNode("option", {
                          key: i - 1,
                          value: `${i - 1}%`
                        }, _toDisplayString(i - 1) + "% ", 9, _hoisted_36)
                      }), 64))
                    ], 512), [
                      [_vModelSelect, _ctx.discountPercentage]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("section", _hoisted_37, [
            _createElementVNode("h3", _hoisted_38, _toDisplayString(_ctx.$t("project.info.address")), 1),
            _createElementVNode("div", _hoisted_39, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.project.address) = $event)),
                placeholder: _ctx.$t('project.info.streetAddress'),
                class: "form-control mb-2"
              }, null, 8, _hoisted_40), [
                [_vModelText, _ctx.project.address]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.project.city) = $event)),
                placeholder: _ctx.$t('project.info.city'),
                class: "form-control mb-2"
              }, null, 8, _hoisted_41), [
                [_vModelText, _ctx.project.city]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.project.country) = $event)),
                placeholder: _ctx.$t('project.info.country'),
                class: "form-control mb-2"
              }, null, 8, _hoisted_42), [
                [_vModelText, _ctx.project.country]
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_43, [
            _createElementVNode("h3", _hoisted_44, _toDisplayString(_ctx.$t("project.info.note")), 1),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.project.note) = $event)),
              rows: "4",
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.project.note]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_component_MapComponent)
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createVNode(_component_MapComponent)
      ])
    ])
  ]))
}